// Vue
import { mixins } from "vue-class-component";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Mixins
import { EventBus } from "../../../../mixins/event_bus/EventBus";

// Utils
import { StringFormat } from "../../../../utils/StringFormat";

// Components
import { Col } from "../../col/Col";
import { Icon } from "../../icon/Icon";
import { Row } from "../../row/Row";

@Component({
  name: "FilterBarItem",
  components: {
    Col,
    Icon,
    Row,
  },
  mixins: [template],
})
export class FilterBarItem extends mixins(EventBus) {
  public isOpen: boolean = false;

  public $refs!: {
    arrow: HTMLElement;
  };

  @Prop()
  public title!: string;

  @Prop()
  public icon!: string;

  @Prop()
  public iconFile!: string;

  @Watch("isOpen")
  public watchIsOpen(isOpen, oldIsOpen) {
    if (isOpen) {
      this.$nextTick(() => {
        let parent = this.$parent;
        if (!parent) {
          return;
        }

        if (parent["getRealParent"]) {
          parent = parent["getRealParent"]();
        }

        const selectedFilter = <HTMLElement>(
          parent?.$el.querySelector(`.${this.$appPrefix}-filter-bar .${this.$appPrefix}-filter-bar__option--active`)
        );

        if (selectedFilter) {
          const leftPosition =
            selectedFilter.getBoundingClientRect().left +
            selectedFilter.offsetWidth / 2 -
            this.$el.getBoundingClientRect().left -
            8;

          this.$refs.arrow.style.left = leftPosition + "px";
        } else {
          this.$refs.arrow.style.left = "15px";
        }
      });
    }
  }

  public created() {
    this.$on("changeOpenedFilterBarItem", this.changeOpenedFilterBarItem);
    this.dispatch("FilterBar", "registerFilterBarItem", [
      { title: this.title, icon: this.icon, iconFile: this.iconFile },
    ]);
  }

  public mounted() {}

  public destroyed() {
    this.$off("changeOpenedFilterBarItem", this.changeOpenedFilterBarItem);
  }

  public changeOpenedFilterBarItem(openedFilterBarItem: string) {
    this.isOpen = openedFilterBarItem == StringFormat.slugify(this.title);
  }

  public close() {
    this.isOpen = false;
    this.dispatch("FilterBar", "closeFilterBarItem", []);
  }
}
